import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import './ThemeToggle.css';

export default function ThemeToggle({ className = '' }) {
    const [theme, setTheme] = useState('light');

    useEffect(() => {
        // Leer tema guardado o usar preferencia del sistema
        const savedTheme = localStorage.getItem('app_theme');
        const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        const initialTheme = savedTheme || systemTheme;
        
        setTheme(initialTheme);
        applyTheme(initialTheme);
    }, []);

    const applyTheme = (newTheme) => {
        document.documentElement.setAttribute('data-theme', newTheme);
    };

    const toggleTheme = () => {
        const newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
        localStorage.setItem('app_theme', newTheme);
        applyTheme(newTheme);
    };

    return (
        <button
            className={`theme-toggle-button ${className}`}
            onClick={toggleTheme}
            aria-label={theme === 'light' ? 'Activar modo oscuro' : 'Activar modo claro'}
            aria-pressed={theme === 'dark'}
            title={theme === 'light' ? 'Modo oscuro' : 'Modo claro'}
        >
            <FontAwesomeIcon 
                icon={theme === 'light' ? faMoon : faSun} 
                className="theme-icon"
            />
        </button>
    );
}





